module.exports = __webpack_public_path__ + "static/mac_app_store@3x-edee7b8a3d73fcfe4cc826b2bad3ff7b.png";